import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { IntegrationAccountDto } from "../dto/financialAccount/integration-account.dto";
import { FinancialAccountType } from "../types/financialAccount";

const c = initContract();

export const integrationAccountContract = c.router(
    {
        updateIntegrationAccount: {
            path: "/:id",
            method: "PATCH",
            body: z.object({
                originalAccountNumber: z
                    .string()
                    .regex(/^\d*$/)
                    .nullable()
                    .optional(),
                originalAccountName: z.string().nullable().optional(),
                originalFinancialType: z
                    .nativeEnum(FinancialAccountType)
                    .nullable()
                    .optional(),
                originalInstitutionName: z.string().nullable().optional(),
                originalFinancialAccountId: z.number().nullable().optional(),
                originalEntityId: z.number().nullable().optional(),
            }),
            responses: {
                200: c.type<IntegrationAccountDto>(),
            },
        },
    },
    {
        pathPrefix: "/integration-account",
    },
);
